export default __webpack_public_path__ + "static/media/boxicons.e2ffa5b9.ttf";